/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsOrganization } from '../models/AwsOrganization';

export class ListAwsOrganizationsResponse {
  /**
  * List of aws organizations.
  */
  'organizations': Array<AwsOrganization>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "organizations",
      "baseName": "organizations",
      "type": "Array<AwsOrganization>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListAwsOrganizationsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

